/* eslint-disable import/no-anonymous-default-export */
import ManageBond from "../pages/treasury/bond/ManageBond";
import AddBond from "../pages/treasury/bond/AddNewBond";
import EditBond from "../pages/treasury/bond/EditBond";
import ViewBond from "../pages/treasury/bond/ViewBond";
import ManageTreasuryBill from "../pages/treasury/treasuryBill/ManageTreasuryBill";
import AddTreasuryBill from "../pages/treasury/treasuryBill/AddTreasuryBill";
import ManageInterBankPlacement from "../pages/treasury/interBankPlacement/ManageInterBankPlacement";
import CreateInterBankPlacement from "../pages/treasury/interBankPlacement/CreateInterBankPlacement";
// import CreateInterBankPlacement from "../pages/treasury/interBankPlacementNew/NewInterBankPlacement";
import ViewInterBankPlacement from "../pages/treasury/interBankPlacement/ViewInterBankPlacement";
import EditInterBankPlacement from "../pages/treasury/interBankPlacement/EditInterBankPlacement";
import ViewTreasuryBill from "../pages/treasury/treasuryBill/ViewTreasuryBill";
import EditTreasuryBill from "../pages/treasury/treasuryBill/EditTreasuryBill";

export default [
  {
    path: "/bond-product",
    component: ManageBond,
  },
  {
    path: "interbank-placement",
    component: ManageInterBankPlacement,
    isProtected: true,
  },
  {
    path: "add-interbank-placement",
    component: CreateInterBankPlacement,
    isProtected: true,
  },
  {
    path: "view-interbank-placement",
    component: ViewInterBankPlacement,
    isProtected: true,
  },
  {
    path: "edit-interbank-placement",
    component: EditInterBankPlacement,
    isProtected: true,
  },
  {
    path: "/new-bond-product",
    component: AddBond,
    isProtected: true,
  },
  {
    path: "/edit-bond-product",
    component: EditBond,
    isProtected: true,
  },
  {
    path: "/detail-bond-product",
    component: ViewBond,
    isProtected: true,
  },
  // -- TREASURY BILL --
  {
    path: "/treasury-bill",
    component: ManageTreasuryBill,
    isProtected: true,
  },
  {
    path: "/new-treasury-bill",
    component: AddTreasuryBill,
    isProtected: true,
  },
  {
    path: "/view-treasury-bill",
    component: ViewTreasuryBill,
    isProtected: true,
  },
  {
    path: "/edit-treasury-bill",
    component: EditTreasuryBill,
    isProtected: true,
  },
];
